import axiosInstance from "../../../../axiosInstance";
import { addSessionData } from "./baseHelper";

export async function GenerateAIMSToken() {
  return await axiosInstance
    .post("/auth/GenerateAIMSToken", {
      aims_secret: "CLOUDVILLE_ADMIN_OAUTH_ACCOUNTSERVICE_BACKEND_API",
    })
    .then((response) => {
      addSessionData({ key: "aimsadmintoken", value: response.data.data });
    })
    .catch((err) => {});
}
